import React, {createContext} from "react";
import LeftDrawer from "../Components/Drawers/LeftDrawer";
import CssBaseline from "@mui/material/CssBaseline";
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {theme} from '../Setup/Theme/theme';
import {Container, Modal} from "../Components";
import BlockUI from "../Components/Elements/BlockUI";
import {Box, Container as ContainerUI} from "@mui/material";
import {RightDrawer} from "../Components/Drawers/RightDrawer";
import {useSelector} from "react-redux";
import {useAppTitle} from "../Hooks/useAppTitle";
import {AppBarOffice} from "../Components";
import {AuthLayoutScreen} from "../Modules/Common/Auth/Components/AuthLayoutScreen";
import {AppBarPublic} from "../Components/AppBars/AppBarPublic";
import useLogout from "../Hooks/useLogout";


export const LayoutContext = createContext({});

const LayoutProvider = ({ children, layout, fullWidth }) => {

    const themeString = useSelector(state => state.app.theme);

    const appTheme = themeString ? themeString : {};
    const muiTheme = createTheme({...theme.coreTheme, ...appTheme});
    const app = useSelector(state => state.app);
    useAppTitle(app.config?.app_name || 'ADNEC: Roster Application');

    const getLayout = (layout) => {

        switch (layout) {
            case 'AUTH':
                return AuthLayout;
            case 'OFFICE':
                return CoreLayout;
            case 'SETUP':
                return SetupLayout;
            case 'PUBLIC':
                return PublicLayout;
            default:
                return undefined;
        }
    };

    const selectedLayout = getLayout(layout);

    if (!selectedLayout) {
        return <LayoutContext.Provider value={{ }}>{children}</LayoutContext.Provider>;
    }

    return (
        <LayoutContext.Provider value={{}}>
            {selectedLayout({ children, theme: muiTheme, fullWidth })}
        </LayoutContext.Provider>
    )
};

const AuthLayout = ({ children }) => {

    const selectedTheme = theme.authLightTheme;

    return (
        <ThemeProvider theme={selectedTheme}>
            <ContainerUI sx={{ height: '100vh', p: '0!important' }} component="main" maxWidth={"xxl"}>
                <AuthLayoutScreen children={children} />
                <Modal />
            </ContainerUI>
        </ThemeProvider>
    );
};

const CoreLayout = ({ children, theme, fullWidth }) => {

    useLogout();

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{
                display: 'flex', 
                flexGrow: 1, 
                backgroundColor: theme.body,
                backgroundImage: 'url(/images/bg.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'fixed',
                minHeight: '100vh',
                overflow: 'hidden'
            }}>
                <CssBaseline/>
                <AppBarOffice/>
                <LeftDrawer/>
                <Container fullWidth={fullWidth}>
                    {children}
                </Container>
                <BlockUI/>
                <Modal/>
                <RightDrawer/>
            </Box>
        </ThemeProvider>
    )
}

const PublicLayout = ({ children, theme, fullWidth }) => {

    return (
        <ThemeProvider theme={ theme }>
            <Box sx={{ display: 'flex', position:'relative', flexGrow:1, backgroundColor:theme.body || '#edf9ffba' }}>
                <CssBaseline />
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        zIndex: 1,
                        background: '#016e95',
                        height: '350px',
                    }}
                />
                <AppBarPublic />
                <Container fullWidth={fullWidth}>
                    {children}
                </Container>
                <Modal />
            </Box>
        </ThemeProvider>
    )
}

const SetupLayout = ({ children, theme }) => {

    useLogout();

    return (
        <ThemeProvider theme={ theme }>
            <Box sx={{ display: 'flex', flexGrow:1, backgroundColor:theme.body }}>
                <CssBaseline />
                <Container
                    maxWidth={{
                        xs: "100vw",
                        sm: "90vw",
                        md: "60vw",
                        lg: "50vw",
                        xl: "40vw",
                    }}
                    minWidth={{
                        xs: "320px",
                        sm: "540px",
                        md: "540px",
                        lg: "540px",
                        xl: "540px",
                    }}
                >
                    {children}
                </Container>
                <Modal />
            </Box>
        </ThemeProvider>
    )
}

export default LayoutProvider;
